export default "__VITE_ASSET__CJB7tP4C__"